import * as React from 'react'
import { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import users from '@services/users'
import subscriptions from '@services/subscriptions'
import { files, services } from '@services/api'
import moment from 'moment'
import { Layout, PageHeader, Select, Input, Button, Spin, Upload, Row, Checkbox, DatePicker } from 'antd'
const { Dragger } = Upload
// prettier-ignore
import {
    searchTypes, textAreaValue, typeSearch, inputSearchValidate, titles, setOptionName, setUserId, resetFields,
    servicePayload, archivePayload, errorModal, warningModal, successModal, errorFatalModal, fileValidator,
    errorFile, checkIfFileExist, tryAddTwice, enterClick, downloadFile, deleteFile, crmModal, countFile,
    textAreaValueJson, subOptionsList, setSubArea, subAreaTitles, getFlyMaxExpiration, successReportModal,
    warningReportModal, jsonParser
} from './Utils/settings'
// prettier-ignore
import {
    wrapper_request, searchInputs, title_, searchType, searchInput, selectInputs, selectSubOption, selectName,
    selectOption, textArea_, uploadDiv, uploadContent, send, none, loadingWrap, checkbox, jsonTextArea, optionStyle,
    selectSubArea, reportDate, reportTextArea, critical_warning_title
} from './style.scss'

@inject((store: any) => {
    const { synonymsStore, servicesStore, popupStore, authStore } = store
    return { synonymsStore, servicesStore, popupStore, authStore }
})
@observer
class GeneralRequest extends Component<any, any> {
    // prettier-ignore
    state = {
        admin: false, loading: false, optionList: null, usersList: [], checkInput: '', textArea: '', requestBy: 1,
        nameInput: titles.chooseUser, optionTitle: titles.chooseOption, typeSearchTitle: titles.phone, userId: '',
        subAreaTitle: titles.subAreaTitle, subOptionTitle: [], providerId: '', optionId: '', fileArrayView: [],
        fileArraySend: [], objectInto: null, checkBox: false, jsonInputElem: '', isSubOption: false, flyExpiration: null,
        isHasBothSubs: false, showDataInputs: false, bothSubsData: {}, serviceId: null, setOptions: this.props.servicesStore.getServices,
        flyMode: false, reportDateSet: '', userReports: null, subFlyId: null, reportSubmitted: false
    }
    settings = {
        multiple: false,
        customRequest: async request => {
            const { formatError, fileTooBig, validList } = titles
            this.setState({ loading: true })
            const { userId, fileArrayView, fileArraySend } = this.state
            const newFile = await request.file
            const formData = new FormData()
            await formData.append('file', newFile)
            const fileIsValid = await fileValidator(formData.get('file'))
            // errors handling
            if (checkIfFileExist(newFile, fileArrayView)) return tryAddTwice(this)
            if (fileIsValid === 'UNSUPPORTED') return errorFile(formatError, validList, this)
            if (fileIsValid === 'FILETOOBIG') return errorFile(fileTooBig, '', this)
            if (fileArrayView.length === 20) return countFile(this)

            try {
                await files
                    .upload(formData, { bucket: 'clients', related: userId, fileType: 'paper', uniq: false })
                    .then(({ data }) => data)
                    .then(({ id, file_check, file_FN, url, file_ext, file_name }) => {
                        // prettier-ignore
                        const fileObjView = {
                            uid: id, validity_: file_check, name: file_FN, url: '', viewUrl: url, viewExt: file_ext
                        }
                        const fileObjSend = {
                            id: id,
                            url: url,
                            fName: file_FN,
                            name: file_name.slice(0, file_name.lastIndexOf('.')),
                            extension: file_ext,
                            relatedId: userId
                        }
                        this.setState({ fileArrayView: [...fileArrayView, fileObjView] })
                        this.setState({ fileArraySend: [...fileArraySend, fileObjSend] })
                        this.setState({ loading: false })
                    })
            } catch (e) {
                request.onError(e => e)
                this.setState({ loading: false })
                errorFatalModal()
            }
        },
        onRemove: async e => await deleteFile(e, this),
        onPreview: async e => await downloadFile(e)
    }
    componentDidMount = async () => {
        const {
            authStore: { roles }
        } = this.props

        if (roles.includes('admin')) this.setState({ admin: true })
        await getFlyMaxExpiration(subscriptions, this)
    }

    handleSubmit = async () => {
        this.setState({ loading: true })
        // prettier-ignore
        const {
            userId, providerId, nameInput, objectInto, checkBox, subOptionTitle, isSubOption, serviceId
        } = this.state
        const useOneOf = checkBox && objectInto ? objectInto : servicePayload(this)
        try {
            services
                .createGeneralRequest({
                    user_id: providerId,
                    person_id: userId,
                    service_id: serviceId,
                    service_content: useOneOf,
                    archive_content: archivePayload(this),
                    sub_option: isSubOption ? subOptionTitle : ''
                })
                .then(async ({ data, status }) => {
                    if (status === 200) return successModal(data, nameInput, this)
                    // if got error
                    resetFields(this, false)
                    errorFatalModal()
                })
                .catch(e => {
                    errorFatalModal()
                    resetFields(this, false)
                    console.log('createGeneralRequest,', e)
                })
        } catch (e) {
            errorFatalModal()
            console.log('createGeneralRequest,', e)
        }
    }

    findUsers = async () => {
        this.setState({ loading: true })
        const {
            servicesStore: { getServices }
        } = this.props
        const { requestBy, checkInput, flyExpiration } = this.state

        const phone = checkInput.length === 10 && checkInput[0] === '0' ? checkInput.slice(1) : checkInput
        const valueRow = requestBy === 1 ? phone : checkInput
        const data = { searchBy: requestBy, value: valueRow }
        // prettier-ignore
        const productsArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15, 18, 19, 20, 21, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67]

        try {
            await users.findUserForRequest(data).then(async res => {
                const { data, status } = res
                // errors, user undefined or has CRM error
                if (status === 201) return crmModal(this, res)
                if (status === 204) return errorModal(this, titles.userNotFound)

                const isAssistant = Array.isArray(data) && data[0].sub_id === 123
                const isCriticalOnly = Array.isArray(data) && data[0].sub_id === 153
                const isSoulCare = Array.isArray(data) && [125, 128, 129, 130, 131, 193].includes(data[0].sub_id)
                // prettier-ignore
                const isCritical = Array.isArray(data) && [153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 184, 185, 186, 187, 188, 195].includes(data[0].sub_id)
                // prettier-ignore
                const isSimpleSmile = Array.isArray(data) && [132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 165, 166, 167, 168, 169, 194, 197, 202, 204].includes(data[0].sub_id)
                const isSimpleSmileOnly = Array.isArray(data) && [132, 133, 134, 139, 140].includes(data[0].sub_id)
                const noGrProduct = Array.isArray(data) && !productsArray.includes(data[0].product_id)
                const flySearch = status === 203 ? data.id : Array.isArray(data) ? data[0].id : null

                // try to find fly subs
                // prettier-ignore
                const { data: flyData } = await users.getSpecialSubscriptionsForGR({ user_id: flySearch, dateFilter: flyExpiration }) // try to find fly data
                const flySubsExisted = flyData.length
                // user hasn't any subscription
                if (!Array.isArray(data) && !flySubsExisted) return errorModal(this, titles.userNotFound)
                if (noGrProduct && !flySubsExisted) return errorModal(this, titles.noGrProduct)

                if (Array.isArray(data) || flySubsExisted) {
                    if (Array.isArray(data) && data[0].parent_provider_id) warningModal()
                }

                // reset perv data
                resetFields(this, true)

                if (Array.isArray(data) && flySubsExisted) {
                    this.setState({ isHasBothSubs: true })
                    this.setState({ bothSubsData: { regularSub: data, flySub: flyData } })
                    await getServices(
                        13,
                        isAssistant,
                        this,
                        [],
                        isSoulCare,
                        isSimpleSmile,
                        isSimpleSmileOnly,
                        isCriticalOnly,
                        isCritical
                    )
                }

                if (Boolean(flySubsExisted) !== Array.isArray(data)) {
                    this.setState({ showDataInputs: true })
                    if (Array.isArray(data)) {
                        const provId =
                            Array.isArray(data) && data[0].parent_provider_id ? data[0].parent_provider_id : data[0].id
                        await getServices(
                            13,
                            isAssistant,
                            this,
                            [],
                            isSoulCare,
                            isSimpleSmile,
                            isSimpleSmileOnly,
                            isCriticalOnly,
                            isCritical
                        )
                        this.setState({ usersList: [...data] })
                        this.setState({ nameInput: data[0].first_name })
                        this.setState({ userId: data[0].id })
                        this.setState({ providerId: provId })
                        this.setState({ serviceId: 13 })
                    }

                    if (flySubsExisted) {
                        await getServices(
                            13,
                            isAssistant,
                            this,
                            flyData[0].options,
                            isSoulCare,
                            isSimpleSmile,
                            isSimpleSmileOnly,
                            isCriticalOnly,
                            isCritical
                        )
                        this.setState({ serviceId: 25 })
                        this.setState({ flyMode: true })
                        this.setState({ usersList: [...jsonParser(flyData)] })
                        this.setState({ nameInput: flyData[0].first_name })
                    }
                }
            })
        } catch (e) {
            console.log('findUserForRequest, ', e)
            this.setState({ loading: false })
            errorFatalModal()
        }
    }

    dateChange = (dateMoment, dateString) => {
        const { usersList } = this.state
        // prettier-ignore
        const reversedDate = dateString.split('-').reverse().join('-')
        const dateCheck = new Date(reversedDate).getTime()
        // prettier-ignore
        const isSubFound = usersList.find(({ dates_range }) => dateCheck >= new Date(dates_range.start).getTime() && dateCheck <= new Date(dates_range.end).getTime())

        if (!isSubFound) {
            this.setState({ userId: '', providerId: '', subFlyId: null, reportDateSet: '' })
            return errorModal(null, titles.reportNotExist)
        }

        const { sub_id, reports, user_id, provider_id, early, late, valid } = isSubFound

        if (early) {
            this.setState({ userId: '', providerId: '', subFlyId: null, reportDateSet: '' })
            return errorModal(null, titles.reportToEarly)
        }

        if (late) {
            this.setState({ userId: '', providerId: '', subFlyId: null, reportDateSet: '' })
            return errorModal(null, titles.reportToLate)
        }

        if (!valid) {
            this.setState({ userId: '', providerId: '', subFlyId: null, reportDateSet: '' })
            return errorModal(null, titles.reportNotExist)
        }

        this.setState({ userId: user_id })
        this.setState({ providerId: provider_id }) // id of main
        this.setState({ subFlyId: sub_id })
        this.setState({ reportDateSet: reversedDate })

        reports ? successReportModal(this, titles.existReport, false) : warningReportModal()
    }

    submitReport = async () => {
        const { reportDateSet, userId, textArea, subFlyId } = this.state
        this.setState({ loading: true })

        const payload = {
            user_special_subscription: subFlyId,
            member_id: userId,
            date: reportDateSet,
            comment: textArea
        }

        try {
            await services
                .addFlyReport(payload)
                .then(async res => {
                    successReportModal(this, titles.reportSuccess, true)
                    this.setState(prevState => ({
                        usersList: prevState.usersList.map(user =>
                            user.sub_id === res.data.user_special_subscription ? { ...user, reports: res.data } : user
                        )
                    }))
                })
                .catch(e => {
                    console.log(e)
                    errorFatalModal()
                })
                .finally(() => {
                    this.setState({ loading: false })
                })
        } catch (e) {
            console.log(e)
            errorFatalModal()
        }
    }

    renderArrays = (arr, method) =>
        arr.map(item => {
            const titleValue = item.title ? item.title : item.option_name ? item.option_name : item.first_name
            const key = item.id || item.user_id
            return (
                <Select.Option className={optionStyle} key={key} value={titleValue} onClick={e => method(item, this)}>
                    {titleValue}
                </Select.Option>
            )
        })
    setLoadingElem = () => (
        <div className={this.state.loading ? loadingWrap : none}>
            <Spin size="large" />
        </div>
    )
    checkboxElem = () => (
        <Checkbox
            onChange={e => {
                this.setState({ checkBox: e.target.checked })
            }}
            className={this.state.admin ? checkbox : none}
            checked={this.state.checkBox}
        >
            {titles.checkboxTitle}
        </Checkbox>
    )
    jsonInputElem = () => (
        <Row className={this.state.checkBox ? jsonTextArea : none}>
            <Input.TextArea
                value={this.state.jsonInputElem}
                onChange={e => textAreaValueJson(e, this)}
                placeholder={'JSON PUT HERE'}
            />
        </Row>
    )

    render() {
        const {
            servicesStore: { generalOptions }
        } = this.props
        // prettier-ignore
        const {
            state: {
                usersList, checkInput, nameInput, textArea, optionTitle, typeSearchTitle,
                providerId, fileArrayView, isSubOption, subOptionTitle, subAreaTitle, isHasBothSubs,
                showDataInputs, flyMode, reportDateSet, reportSubmitted, optionId
            },
            findUsers, handleSubmit, renderArrays, setLoadingElem, checkboxElem, jsonInputElem, dateChange, submitReport
        } = this
        // prettier-ignore
        const {
            title, searchTitle, searchBtn, chooseOption, description, sendBtnTitle,
            uploadTitle, reportTitle, descriptionReport, needDocument
        } = titles

        const isFlyRequest = flyMode ? usersList.slice(0, 1) : usersList
        const isCriticalUniqueCheck = optionId && optionId == 33 && !fileArrayView.length
        const optionVisible = !generalOptions.length || generalOptions.length === 1
        const searchBtnVisible = checkInput.length < 2 && true
        const nameVisible = isFlyRequest.length === 1 || (!isFlyRequest.length && true)

        const showSendBtn = () => {
            // prettier-ignore
            if (!isSubOption) return textArea.length > 6 && optionTitle !== chooseOption && !isCriticalUniqueCheck ? send : none
            return textArea.length > 6 && optionTitle !== chooseOption && subOptionTitle.length ? send : none
        }

        const typeList = () => renderArrays(searchTypes, typeSearch)
        const optionList = () => renderArrays(generalOptions, setOptionName)
        const userList = () => renderArrays(isFlyRequest, setUserId)
        const subOptions = () => renderArrays(subOptionsList, () => {})
        const subAreaList = () => renderArrays(subAreaTitles, setSubArea)
        const loadingCircle = () => setLoadingElem()
        const checkboxElement = () => checkboxElem()
        const jsonTextarea = () => jsonInputElem()

        return (
            <Layout className={wrapper_request}>
                {checkboxElement()}
                {jsonTextarea()}
                {loadingCircle()}
                <PageHeader onBack={() => window.history.back()} title={title} />
                {/*search row*/}
                <Fragment>
                    <Row className={searchInputs}>
                        <div className={title_}>{searchTitle}</div>
                        <Select className={searchType} value={typeSearchTitle}>
                            {typeList()}
                        </Select>
                        <Input
                            className={searchInput}
                            onChange={e => inputSearchValidate(e.target.value, this)}
                            type={'text'}
                            id={'code'}
                            value={checkInput}
                            onKeyPress={e => enterClick(e, this)}
                        />
                        <Button className={searchBtn} onClick={findUsers} disabled={searchBtnVisible}>
                            {searchBtn}
                        </Button>
                    </Row>
                </Fragment>
                {/*search row*/}

                <Fragment>
                    <Row className={selectInputs}>
                        {isHasBothSubs && (
                            <Select className={selectSubArea} value={subAreaTitle}>
                                {subAreaList()}
                            </Select>
                        )}
                        {showDataInputs && (
                            <Select className={selectName} value={nameInput} disabled={nameVisible}>
                                {userList()}
                            </Select>
                        )}
                        {showDataInputs && (
                            <Select
                                className={flyMode && !reportSubmitted ? none : selectOption}
                                value={optionTitle}
                                disabled={optionVisible}
                            >
                                {optionList()}
                            </Select>
                        )}
                        {isSubOption && (
                            <Select
                                mode="multiple"
                                className={selectSubOption}
                                placeholder={titles.subOption_t}
                                onChange={e => this.setState({ subOptionTitle: e })}
                                defaultValue={subOptionTitle}
                            >
                                {subOptions()}
                            </Select>
                        )}
                        {flyMode && !reportSubmitted && (
                            <DatePicker
                                className={reportDate}
                                format={'DD-MM-YYYY'}
                                placeholder={reportTitle}
                                onChange={dateChange}
                                value={reportDateSet ? moment(reportDateSet) : null}
                            />
                        )}
                        {flyMode && !reportSubmitted && reportDateSet && (
                            <Input.TextArea
                                value={textArea}
                                onChange={e => textAreaValue(e.target.value, this)}
                                placeholder={descriptionReport}
                                className={reportTextArea}
                            />
                        )}
                        {flyMode && !reportSubmitted && reportDateSet && (
                            <Button
                                className={''}
                                onClick={submitReport}
                                disabled={!reportDateSet || textArea.length < 6}
                            >
                                {sendBtnTitle}
                            </Button>
                        )}
                    </Row>
                </Fragment>

                {showDataInputs && (
                    <Fragment>
                        <Row className={flyMode && !reportSubmitted ? none : textArea_}>
                            <Input.TextArea
                                value={textArea}
                                onChange={e => textAreaValue(e.target.value, this)}
                                placeholder={description}
                            />
                        </Row>
                    </Fragment>
                )}

                {showDataInputs && (
                    <Fragment>
                        <Row className={flyMode && !reportSubmitted ? none : uploadDiv}>
                            <Dragger
                                {...this.settings}
                                disabled={!providerId && true}
                                listType="picture"
                                fileList={fileArrayView}
                            >
                                <div className={uploadContent}>
                                    <p>{uploadTitle}</p>
                                </div>
                            </Dragger>
                        </Row>
                    </Fragment>
                )}

                <Button className={showSendBtn()} onClick={handleSubmit}>
                    {sendBtnTitle}
                </Button>
                {isCriticalUniqueCheck ? <div className={critical_warning_title}>{needDocument}</div> : null}
            </Layout>
        )
    }
}

export default withRouter(GeneralRequest)
